module.exports = __webpack_public_path__ + "static/media/newlogo.eeec6dae.png";